import React from 'react';
import { Link, Outlet } from "react-router-dom";
import { MarkGithubIcon } from "@primer/octicons-react";
import Footer from './Footer';

import { useContext } from "react";
import AuthContext from "./../store/auth-context";

function Header() {
    const authCtx = useContext(AuthContext);
    //console.log("authCtx", authCtx);

    function logoutHandler() {
      authCtx.logout();
    }

    return (
      <>
        <div className="container">
          <header className="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
            <Link
              className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none"
              to={authCtx.isLoggedIn ? "/react" : "/react/login"}
            >
              <svg className="bi me-2" width="40" height="32">
                <use xlinkHref="#bootstrap" />
              </svg>
              <span className="fs-4">Marc Houben</span>
            </Link>
            <ul className="nav nav-pills">
              {authCtx.isLoggedIn && (
                <>
                  <li className="nav-item">
                    <a href="https://github.com/MarcHouben?tab=repositories">
                      <MarkGithubIcon size="medium" fill="#000" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" aria-current="page" to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/test">
                      Test
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/album">
                      Album
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/carousel">
                      Carousel
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/customcard">
                      Custom Card
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/maaltijden">
                      Maaltijden
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/personalia">
                      Personalia
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/react/upload">
                      Upload
                    </Link>
                  </li>
                </>
              )}
              {!authCtx.isLoggedIn && (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to={authCtx.isLoggedIn ? "/" : "/react/login"}
                  >
                    {" "}
                    {/* className="nav-link active" */}
                    Login
                  </Link>
                </li>
              )}
              {authCtx.isLoggedIn && (
                <>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={authCtx.isLoggedIn ? "/" : "/react/login"}
                      onClick={logoutHandler}
                    >
                      Uitloggen
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a href="https://trello.com/w/azltransitiedashboard">
                      <i className="bi bi-trello"></i>
                    </a>
                  </li>
                </>
              )}
            </ul>
          </header>
        </div>

        <Outlet />
        <Footer />
      </>
    );
}

export default Header